/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { type WithTrackingItemRequestBuilder, WithTrackingItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/images/housekeeping/clean-up/progress
 */
export interface ProgressRequestBuilder extends BaseRequestBuilder<ProgressRequestBuilder> {
    /**
     * Gets an item from the MomentumAPI.api.images.housekeeping.cleanUp.progress.item collection
     * @param trackingId Unique identifier of the item
     * @returns {WithTrackingItemRequestBuilder}
     */
     byTrackingId(trackingId: string) : WithTrackingItemRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const ProgressRequestBuilderUriTemplate = "{+baseurl}/api/images/housekeeping/clean-up/progress";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ProgressRequestBuilderNavigationMetadata: Record<Exclude<keyof ProgressRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byTrackingId: {
        requestsMetadata: WithTrackingItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["trackingId"],
    },
};
/* tslint:enable */
/* eslint-enable */
